import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import { type FC } from "react";

import * as Styled from "~/feature/search/components/SearchEntityBlock/SearchEntityBlock.styles";
import type { ISearchInsightsSummary } from "~/feature/search/type";

interface IInsightsSummaryRowProps extends ISearchInsightsSummary {
  onSelect?: (query: string) => void;
}

export const InsightsSummaryRow: FC<IInsightsSummaryRowProps> = ({
  query,
  total,
  onSelect,
}) => (
  <Styled.EntityBlock
    data-testid="search-insights-row"
    onMouseDown={(e) => e.preventDefault()}
    onClick={() => onSelect?.(query)}
  >
    <Styled.InsightsImagePlaceholder>
      <QueryStatsIcon fontSize="medium" color="info" />
    </Styled.InsightsImagePlaceholder>

    <Styled.EntityInfo>
      <Styled.EntityTitle variant="body2">{query} insights</Styled.EntityTitle>
      <Styled.EntitySubtitle variant="caption">
        {total} {total === 1 ? "article" : "articles"} — See all {query} insights
      </Styled.EntitySubtitle>
    </Styled.EntityInfo>

    <ArrowForwardIosIcon sx={{ fontSize: 12 }} color="disabled" />
  </Styled.EntityBlock>
);
